import{a as e}from"./chunk-RAAYCPUM.js";function u(...n){return e(r,n)}var r=(n,o)=>({[o]:n});export{u as a};
